import { OrderWithEvents } from '../../types/orders';
import { Actions, ActionTypes } from './actions';
import { AccountAdminUser } from '../../types/management-auth';

export interface State {
    isLoading: boolean;
    isNotFound: boolean;
    order: OrderWithEvents | undefined;
    createCommentIsLoading: boolean;
    users: AccountAdminUser[];
}

export const initialState: State = {
    isLoading: false,
    isNotFound: false,
    order: undefined,
    createCommentIsLoading: false,
    users: [],
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetOrder:
            if (state.order && state.order.order_id === action.payload.orderId) {
                return { ...state };
            }
            return {
                ...state,
                order: undefined,
                isLoading: true,
                isNotFound: false,
            };

        case ActionTypes.OrderResponse:
            return {
                ...state,
                order: action.payload.order,
                isLoading: false,
                isNotFound: false,
            };

        case ActionTypes.OrderNotFoundResponse:
            return {
                ...state,
                isLoading: false,
                isNotFound: true,
                order: undefined,
            };

        case ActionTypes.CreateComment:
            return {
                ...state,
                createCommentIsLoading: true,
            };

        case ActionTypes.CreateCommentResponse:
            return {
                ...state,
                createCommentIsLoading: false,
                order: action.payload.order,
            };

        case ActionTypes.DeleteComment:
            return {
                ...state,
                createCommentIsLoading: true,
            };

        case ActionTypes.DeleteCommentResponse:
            return {
                ...state,
                createCommentIsLoading: false,
                order: action.payload.order,
            };

        case ActionTypes.FetchUsersResponse:
            return {
                ...state,
                users: action.payload.users,
            };

        default:
            return state;
    }
}
